
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebfd9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebfd9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hCyg7", function(module, exports) {

$parcel$export(module.exports, "setupEventListeners", () => $cd408f6903d3d940$export$2e773a31cc80e22d);
$parcel$export(module.exports, "saveUser", () => $cd408f6903d3d940$export$ca0e1882e225378b);

var $8fZH8 = parcelRequire("8fZH8");

var $hbTNR = parcelRequire("hbTNR");
let $cd408f6903d3d940$var$usersDataCache = null;
let $cd408f6903d3d940$var$isSortedAscending = false;
let $cd408f6903d3d940$var$currentDisplayedUsers = [];
const $cd408f6903d3d940$var$usersListElement = document.getElementById("usersList");
// Update the users list based on the current displayed users
const $cd408f6903d3d940$var$updateUsersList = (users)=>{
    (0, $hbTNR.createUsersList)(users, $cd408f6903d3d940$var$usersListElement);
};
// Handle the logic when sorting users
const $cd408f6903d3d940$var$handleSortClick = ()=>{
    $cd408f6903d3d940$var$isSortedAscending = !$cd408f6903d3d940$var$isSortedAscending;
    const sortedUsers = (0, $8fZH8.sortUsers)($cd408f6903d3d940$var$currentDisplayedUsers, $cd408f6903d3d940$var$isSortedAscending);
    $cd408f6903d3d940$var$updateUsersList(sortedUsers);
};
// Handle the logic when input is detected in the search box
const $cd408f6903d3d940$var$handleSearchInput = (searchString)=>{
    if ($cd408f6903d3d940$var$usersDataCache) {
        $cd408f6903d3d940$var$currentDisplayedUsers = (0, $8fZH8.filterUsers)($cd408f6903d3d940$var$usersDataCache, searchString);
        $cd408f6903d3d940$var$updateUsersList($cd408f6903d3d940$var$currentDisplayedUsers);
    }
};
// Setup event listeners for DOM elements
const $cd408f6903d3d940$export$2e773a31cc80e22d = (usersData)=>{
    $cd408f6903d3d940$var$usersDataCache = usersData;
    $cd408f6903d3d940$var$currentDisplayedUsers = usersData;
    document.getElementById("sortBtn").onclick = $cd408f6903d3d940$var$handleSortClick;
    document.getElementById("searchInput").oninput = function() {
        $cd408f6903d3d940$var$handleSearchInput(this.value);
    };
};
// Save a new user and update the users list in the DOM
const $cd408f6903d3d940$export$ca0e1882e225378b = (newUser)=>{
    console.log("Saving user:", newUser);
    $cd408f6903d3d940$var$usersDataCache.push(newUser);
    $cd408f6903d3d940$var$updateUsersList($cd408f6903d3d940$var$usersDataCache);
};

});
parcelRegister("8fZH8", function(module, exports) {

$parcel$export(module.exports, "filterUsers", () => $602f94ba1d2379e9$export$3e8d7a10dddfc47e);
$parcel$export(module.exports, "sortUsers", () => $602f94ba1d2379e9$export$a9ef1d2c1af33cd2);
// userUtils.js
const $602f94ba1d2379e9$export$3e8d7a10dddfc47e = (users, searchString)=>{
    const regex = new RegExp(`^${searchString}`, "i");
    return users.filter(({ name: name })=>regex.test(name));
};
const $602f94ba1d2379e9$export$a9ef1d2c1af33cd2 = (users, ascending)=>users.slice().sort((a, b)=>{
        const comparison = a.name.localeCompare(b.name);
        return ascending ? comparison : -comparison;
    });

});

parcelRegister("hbTNR", function(module, exports) {

$parcel$export(module.exports, "createUsersList", () => $c83ec0193eeb9a58$export$2b1148384ec5d90a);
// domUtils.js
const $c83ec0193eeb9a58$export$3493b8991d49f558 = ({ name: name, username: username, email: email, address: { city: city, zipcode: zipcode }, phone: phone })=>{
    return `<li class="userInfo">
            <p>Name: ${name}</p>
            <p>Username: ${username}</p>
            <p>Email: ${email}</p>
            <p>City: ${city}</p>
            <p>Zipcode: ${zipcode}</p>
            <p>Phone: ${phone}</p>
          </li>`;
};
const $c83ec0193eeb9a58$export$2b1148384ec5d90a = (users, list)=>{
    list.innerHTML = "";
    users.forEach((user)=>{
        list.innerHTML += $c83ec0193eeb9a58$export$3493b8991d49f558(user);
    });
};

});


// api.js
const $96e14f2a7c3555e4$var$API_URL = "https://jsonplaceholder.typicode.com/users";
const $96e14f2a7c3555e4$export$8134c072fddab6a5 = async ()=>{
    try {
        const response = await fetch($96e14f2a7c3555e4$var$API_URL);
        if (!response.ok) throw new Error(`Error fetching data with status: ${response.status}`);
        return response.json();
    } catch (error) {
        console.error(error);
        return null;
    }
};



var $hCyg7 = parcelRequire("hCyg7");

var $hbTNR = parcelRequire("hbTNR");
// App Initialization
const $2b6e161c9edcf319$var$init = async ()=>{
    const usersData = await (0, $96e14f2a7c3555e4$export$8134c072fddab6a5)();
    if (usersData) {
        const usersList = document.getElementById("usersList");
        (0, $hbTNR.createUsersList)(usersData, usersList);
        (0, $hCyg7.setupEventListeners)(usersData);
    }
};
$2b6e161c9edcf319$var$init();


//# sourceMappingURL=index.fc73423d.js.map
